import global from './Globals';

const Table = {
  tableBodyBg: 'white',
  tableHeaderBg: global.primary400,
  tableHeaderText: global.grey400,
};

export default Table;
